var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-dialog',{ref:"baseDialog",on:{"positiveAction":_vm.onSave}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("comBoxDetail.control.iotMeterReadingHint"))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }